import { Pipe, PipeTransform } from '@angular/core';
import { StringHelper } from '../helpers/string-helper';

@Pipe({
  name: 'printAddress',
})
export class PrintAddressPipe implements PipeTransform {
  transform(
    line1: string,
    postalCode: string,
    city: string,
    floor?: string
  ): string {
    let address = StringHelper.join(
      [line1, StringHelper.join([postalCode, city], ' ')],
      ', '
    );

    if (floor != null) {
      floor = '(Verdiep: ' + floor + ')';
      address = StringHelper.join([address, floor], ' ');
    }

    return address;
  }
}
